import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/SEO_logo.svg'


const _hoisted_1 = {
  class: "content",
  id: "content"
}
const _hoisted_2 = { class: "c-toast-box" }

import { ref, watchEffect, computed, watch, onMounted } from 'vue';
import Header from './components/Header.vue';
import LeftMenu from './components/LeftMenu.vue';
import SubscriptionWarningBar from './components/subscription/SubscriptionWarningBar.vue';

import { useRoute } from 'vue-router';
import Toast from './components/Toast.vue';
import { toastStore } from './stores/toast/Toast';
import { isEmpty } from 'lodash';
import { userStore } from '@/stores/authStore';
import { profileStore } from '@/stores/profile';
import { regionStore } from '@/stores/regionStore';
import { projectStore } from '@/stores/project';
import { removeData } from '@/utils/AsyncService';

import { useMeta } from 'vue-meta';
import imgUrl from '@/assets/images/SEO_logo.svg';
import { $t } from '@/plugins/translation';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isHeader = ref(false);
const type = ref('home');
const isLeft = ref(false);
const route = useRoute();
// const router = useRouter();

const authModule = userStore();
const profileModule = profileStore();
const projectModule = projectStore();
const storeToast = toastStore();
const isToast = ref(storeToast.toastData);
const region = regionStore();

const showWarning = ref(true);

const isShowWarningSubscriptionBar = computed(
  () =>
    !['home', 'setting', 'Profile', 'Recruitment', 'instructionNewRegister', 'join'].includes(
      route.name as unknown as string,
    ) &&
    authModule.login &&
    showWarning.value &&
    projectModule.isWarningSubscription,
);

// check device
const isMobile = ref(true);

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 767;
};

useMeta({
  title: $t('metadata', 'title'),
  meta: [
    { vmid: 'description', name: 'description', content: $t('metadata', 'description') },
    { vmid: 'keywords', name: 'keywords', content: $t('metadata', 'keywords') },
    { vmid: 'og:type', name: 'og:type', content: 'article' },
    { vmid: 'og:title', name: 'og:title', content: $t('metadata', 'title') },
    { vmid: 'og:description', name: 'og:description', content: $t('metadata', 'description') },
    { vmid: 'og:url', name: 'og:url', content: 'https://eposo.ai/' }, // 실제 URL
    { vmid: 'og:image', name: 'og:image', content: '/assets/images/SEO_logo.svg' }, // 실제 이미지 경로
    { vmid: 'og:image', name: 'og:image', content: imgUrl }, // 실제 이미지 경로
  ],
});

watchEffect(() => {
  if (isEmpty(route.meta)) return;
  isHeader.value = route.meta.isHeader == false ? false : true; // undefined 경우 true
  type.value = route.meta.type as string;
  isLeft.value = route.meta.isLeft == false ? false : true; // undefined 경우 true
  isToast.value = storeToast.toastData;
});

onMounted(async () => {
  if (authModule.login) await profileModule.getUserProfile();
  removeData('projectList');
  removeData('profile');
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
  isMobile.value
    ? document.getElementById('app')?.classList.add('mo')
    : document.getElementById('app')?.classList.add('pc');
});

watch(
  () => authModule.login,
  async (isLogin) => {
    if (isLogin) await profileModule.getUserProfile();
    region.setLang();
  },
  { immediate: true },
);

watch(
  () => projectModule.selectedProject.totalMember,
  () => {
    if (projectModule.isWarningSubscription) showWarning.value = true;
  },
);

// watch(
//   lang,
//   () => {
//     if(!lang.value) return;
//     console.log(lang.value)
//     const app = getCurrentInstance()?.appContext.app;
//     console.log(getCurrentInstance())

//     app?.runWithContext(() => {
//       const strings = STRINGS[lang.value];
//       console.log(strings)
//       useMeta({
//         title: strings.metadata.title,
//         meta: [
//           { vmid: 'description', name: 'description', content: strings.metadata.description },
//           { vmid: 'keywords', name: 'keywords', content: strings.metadata.keywords },
//           { vmid: 'og:type', name: 'og:type', content: 'article' },
//           { vmid: 'og:title', name: 'og:title', content: strings.metadata.title },
//           { vmid: 'og:description', name: 'og:description', content: strings.metadata.description },
//           { vmid: 'og:url', name: 'og:url', content: 'https://eposo.ai/' },  // 실제 URL
//           { vmid: 'og:image', name: 'og:image', content: '/assets/images/SEO_logo.svg' },  // 실제 이미지 경로
//           { vmid: 'og:image', name: 'og:image', content: imgUrl },  // 실제 이미지 경로
//         ]
//       });
//     });
//   },
//   { deep: true, immediate: true },
// );

// const handleDebouncedScroll = (event: any) => {
//   console.log(event)
//   console.log('handleDebouncedScroll');
// }

// onMounted(() => {
//   document.getElementById('content')!.addEventListener('scroll', handleDebouncedScroll);
// });
// onUnmounted(() => {
//   document.getElementById('content')!.removeEventListener('scroll', handleDebouncedScroll);
// })

return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_metainfo),
    (isLeft.value)
      ? (_openBlock(), _createBlock(LeftMenu, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(`wrap ${!isHeader.value && !isLeft.value && 'wrap--expand'}`)
    }, [
      (isHeader.value)
        ? (_openBlock(), _createBlock(Header, {
            key: 0,
            type: type.value
          }, null, 8, ["type"]))
        : _createCommentVNode("", true),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "c-seo s-hide" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "SEO Meta Image logo"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_RouterView)
      ])
    ], 2),
    (isShowWarningSubscriptionBar.value)
      ? (_openBlock(), _createBlock(SubscriptionWarningBar, {
          key: 1,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showWarning.value = false))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(isToast.value, (item, index) => {
        return (_openBlock(), _createBlock(Toast, {
          key: index,
          isToast: isToast.value[index].text.length > 0,
          icon: isToast.value[index].icon,
          close: isToast.value[index].close
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(isToast.value[index].text), 1)
          ]),
          _: 2
        }, 1032, ["isToast", "icon", "close"]))
      }), 128))
    ])
  ], 64))
}
}

})